export const filters = {
    linebreaks(value) {
        if (!value) return '';
        return value.replace(/(?:\r\n|\r|\n)/g, '<br>');
    },

    percentage(value, decimals = 0) {
        if (!value) value = 0;
        value = value * 100;
        value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
        return value + '%';
    }
};

export default filters;
